import { render, staticRenderFns } from "./brand-parameters.vue?vue&type=template&id=e3bea334&scoped=true"
import script from "./brand-parameters.vue?vue&type=script&lang=js"
export * from "./brand-parameters.vue?vue&type=script&lang=js"
import style0 from "./brand-parameters.vue?vue&type=style&index=0&id=e3bea334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bea334",
  null
  
)

export default component.exports